import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FAQ = [
  { q: "Can you work with our existing software?", a: "Yes. We work with most commonly used business platforms — QuickBooks, Microsoft 365, Google Workspace, Dispatch software, CRMs and more — after a short onboarding and training." },
  { q: "Can you answer our business phone?", a: "Yes. We answer, log, and route calls professionally on your behalf." },
  { q: "Can you organize our office paperwork?", a: "Yes. Both physical and digital — including scanning, filing systems, and secure cloud storage." },
  { q: "Do you provide weekly office visits?", a: "Yes, for eligible GTA clients. We come on-site to handle filing, document scanning, employee files, and admin projects." },
  { q: "Do you sign confidentiality agreements?", a: "Absolutely. NDAs are standard at onboarding and we treat all client information with the utmost discretion." },
  { q: "Can you work with multiple departments?", a: "Yes. We can split hours across departments — operations, HR, customer support, and bookkeeping." },
  { q: "Do you offer tax preparation or accounting advice?", a: "No. We provide bookkeeping support and data entry only — not tax filing or accounting advisory services." },
  { q: "How quickly can we start?", a: "Most engagements begin within 5–7 business days after the consultation and signed agreement." },
];

export default function FAQ_Section() {
  return (
    <section id="faq" className="relative py-28 lg:py-36" data-testid="faq-section">
      <div className="container-apex">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4">
            <div className="overline">FAQ</div>
            <h2 className="heading-display text-4xl sm:text-5xl mt-5">
              Questions, <span className="text-[#16A34A]">answered.</span>
            </h2>
            <p className="mt-5 text-muted-foreground">
              Still curious? Book a consultation — we'll happily answer anything specific to your business.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQ.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-border" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-display font-bold text-lg lg:text-xl hover:no-underline hover:text-[#16A34A]">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
